module.exports = __webpack_public_path__ + "img/bot-icon.f194ecf1.png";